import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Checkpoint from "./components/Checkpoint";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Checkpoint />} />
          <Route path="*" element={<Checkpoint />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
